import { IsExpandedEntryJSON } from "../../../src/apidefs";

export function getEntryArtists(entry: any): string[] | undefined {
  if (!entry) {
    return undefined;
  }

  if (entry.user && entry.user.username) {
    return [entry.user.username];
  }

  if (entry.username) {
    return [entry.username];
  }

  if (IsExpandedEntryJSON(entry)) {
    const names = [
      entry.username_1,
      entry.username_2,
      entry.username_3,
      entry.username_4,
      entry.username_5,
    ].filter((x): x is string => !!x);

    if (names.length) {
      return names;
    }
  }

  return undefined;
}
